<div  class="main-container" [cdkCopyToClipboard]="this.clipboardText" [cdkCopyToClipboardAttempts]="8">
  <mat-icon [matTooltip]="this.clipboardText">content_copy</mat-icon>
  <span>{{text}}</span>
</div>
